export default "/images/success-theme.png?f279372564c4bdd040b721c2460a871a";